// extracted by mini-css-extract-plugin
export default {"title":"MemberApplicationModal_title__7TOQq"};